import {
  BusinessAccountItem,
  BusinessAccountListItem,
  BusinessAccountResponse,
  ServiceAccount,
  ServiceAccountListItem,
  ServiceAccountResponse,
  Beneficiaries,
  BeneficiariesResponse,
} from '@shared/models';

export const mapBusinessAccountList = (response: BusinessAccountResponse): BusinessAccountListItem => {
  const { content = [], totalElements = 0, hasNext } = response || {};

  const items: BusinessAccountItem[] = content.map((businessAccount) => ({
    ...businessAccount,
  }));

  return {
    items,
    totalElements,
    hasNext,
  };
};

export const mapServiceAccountList = (response: ServiceAccountResponse): ServiceAccountListItem => {
  const { content = [], totalElements = 0, hasNext } = response || {};

  const items: ServiceAccount[] = content.map((serviceAccount) => {
    const serviceAccountRoles: string[] = [];
    serviceAccount.roles?.forEach((role) => serviceAccountRoles.push(role.name));
    const role = serviceAccountRoles.join(',');

    return { ...serviceAccount, role };
  });

  return {
    items,
    totalElements,
    hasNext,
  };
};

export const mapBusinessAccountBeneficiaryList = (beneficiaries: BeneficiariesResponse): Beneficiaries[] => {
  const { content = [] } = beneficiaries || {};

  return content.map((item) => {
    const { id, firstName, lastName, middleName, primaryPhoneNumber, primaryEmail, controller, verificationStatus } = item;

    return {
      id,
      initials: `${firstName.charAt(0)}${lastName.charAt(0)}`,
      fullName: `${firstName}${middleName ? ' ' + middleName : ''} ${lastName}`,
      phoneNumber: primaryPhoneNumber?.number,
      email: primaryEmail?.value,
      controller,
      verification: verificationStatus?.status ?? 'UNVERIFIED',
    };
  });
};
